module.exports = __webpack_public_path__ + "img/downloadApp7.5edc911c.svg";